import styled from '@emotion/styled';
import { ActivityIndicator } from '@trinity/chat-components/components/presentation/ActivityIndicator.js';

export const AppInitializing = () => {

  return (
    <Root>
      <ActivityIndicator />
    </Root>
  );
};

const Root = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: `calc(100vh - var(--navbar-height))`,
});